export enum TypingLoaderType {
  DARK = 'dark',
  LIGHT = 'light',
}
